import { render } from "./InformationMainFunctionBlock.vue?vue&type=template&id=6e0814a8&scoped=true&ts=true"
import script from "./InformationMainFunctionBlock.vue?vue&type=script&lang=ts"
export * from "./InformationMainFunctionBlock.vue?vue&type=script&lang=ts"

import "./InformationMainFunctionBlock.vue?vue&type=style&index=0&id=6e0814a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0814a8"]])

export default __exports__